import { MessageItemProps } from '../types';

export const getMessageType = ({ incoming, messageType }: MessageItemProps) => {
  if (incoming) return 'inbound';
  if (messageType === 'reply') return 'outbound';
  if (messageType?.includes('convert_event')) return 'convert';
  return 'system';
};
